(function () {
  var done = false;

  function init() {
    if (done) return;
    var bar = document.querySelector('[x-data*="xStickyATC"]');
        var atc = document.querySelector('.main-product [data-cta], .main-product form[action*="/cart/add"] [type="submit"]');
    if (!bar || !atc) return;

    done = true;
    bar.removeAttribute('x-show');
    bar.style.removeProperty('display');
    bar.classList.add('soi-sticky-bar');

      var pay = null;
    var seen = { atc: false, pay: false };

    function update(){ bar.classList.toggle('soi-sticky-on', !(seen.atc || seen.pay)); }
    function watch(el, key){
      if (!el) return;
      new IntersectionObserver(function(e){ seen[key] = e[0].isIntersecting; update(); },
        { threshold: 0 }).observe(el);
    }
    watch(atc, 'atc');
    watch(pay, 'pay');
    update();

    new MutationObserver(function(){
      if (bar.style.display === 'none') bar.style.removeProperty('display');
    }).observe(bar, { attributes: true, attributeFilter: ['style'] });
  }

  // try as soon as possible, and keep trying while the page builds
  var mo = new MutationObserver(function(){
    init();
    if (done) mo.disconnect();
  });

  function start(){
    init();
    if (!done) mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function(){ init(); mo.disconnect(); }, 4000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();